import React from 'react';
import { useSelector } from 'react-redux';
import translate from '../translate';
import { Link } from 'react-router-dom';

function Footer() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'footer';

    function backToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    return (
        <footer className="footer theme-light-bg pt-95">
        <div className="footer-widgets">
            <div className="container">
                <div className="row mt-none-30">
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 custom-col mt-30">
                        <div className="widget">
                            <div className="about-widget">
                                <p><b>{translate(componentName, 'headquarter', language)}</b></p>
                                <p><i className="far fa-map-marker-alt"></i> {translate(componentName, 'address1', language)}, {translate(componentName, 'phone1', language)}</p>
                                <p><b>{translate(componentName, 'branch', language)}</b></p>
                                <p><i className="far fa-map-marker-alt"></i> {translate(componentName, 'address2', language)}, {translate(componentName, 'phone2', language)}</p>
                                <p><i className="far fa-envelope"></i> {translate(componentName, 'email', language)}</p>
                                <div className="social-links mt-40">
                                    <Link to="#0"><i className="fab fa-facebook-f"></i></Link>
                                    <Link to="#0"><i className="fab fa-twitter"></i></Link>
                                    <Link to="#0"><i className="fab fa-instagram"></i></Link>
                                    <Link to="#0"><i className="fab fa-linkedin-in"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 custom-col mt-30">
                        <div className="widget">
                            <h3 className="widget-title">{translate(componentName, 'servicesTitle', language)}</h3>
                            <ul>
                                <li><Link to="/services">{translate(componentName, 'service1', language)}</Link></li>
                                <li><Link to="/services">{translate(componentName, 'service2', language)}</Link></li>
                                <li><Link to="/services">{translate(componentName, 'service3', language)}</Link></li>
                                <li><Link to="/services">{translate(componentName, 'service4', language)}</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 custom-col mt-30">
                        <div className="widget">
                            <h3 className="widget-title">{translate(componentName, 'quickLinksTitle', language)}</h3>
                            <ul>
                                <li><Link to="/about">{translate(componentName, 'quickLink1', language)}</Link></li>
                                <li><Link to="/services">{translate(componentName, 'quickLink2', language)}</Link></li>
                                <li><Link to="/contact">{translate(componentName, 'quickLink4', language)}</Link></li>
                                <li><Link to="#">{translate(componentName, 'quickLink5', language)}</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="copyright">
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <p>{translate(componentName, 'copyright', language)} </p>
                    </div>
                    <div className="col-md-4">
                        <div className="backtotop">
                            <button onClick={()=>backToTop()} data-backtotop><i className="far fa-angle-up"></i> {translate(componentName, 'backToTop', language)}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    );
}

export default Footer;